import { css } from "@emotion/react";

import { Divider } from "components/shared/library/Divider";
import { Markdown } from "components/shared/library/Markdown";
import { Typography } from "components/shared/library/Typography";

import { white } from "constants/colors";

const style = {
  wrapper: css({
    display: "flex",
    flexDirection: "column",
    background: white,
    borderRadius: 16,
    padding: "16px 24px 24px 24px",
  }),
  content: css({
    display: "flex",
    flexDirection: "column",
    gap: 8,
  }),
  divider: css({
    margin: "16px 0px",
  }),
  blur: css({
    filter: "blur(4px)",
  }),
};

type Props = {
  description?: string;
  requirements?: string;
  blur?: boolean;
};

export const JobDetailWidget = ({ description, requirements, blur }: Props) => {
  if (!description && !requirements) return null;
  return (
    <div css={[style.wrapper, blur && style.blur]}>
      {description && (
        <div css={style.content}>
          <Typography weight="bold">Description</Typography>
          <Typography>
            <Markdown>{description}</Markdown>
          </Typography>
        </div>
      )}
      {description && requirements && <Divider customCss={style.divider} />}
      {requirements && (
        <div css={style.content}>
          <Typography weight="bold">Requirements</Typography>
          <Typography>
            <Markdown>{requirements}</Markdown>
          </Typography>
        </div>
      )}
    </div>
  );
};
